import React from 'react'

export default props => (
    <tbody style={{
		backgroundColor: props.backgroundColor
	}}>
		{props.children}
	</tbody>
)
